import React, { useState } from "react"
import "../../styles/header.css"
import Locale from "../locale/Locale"
import { nav } from "../../assets/data/constants"
import { Link } from "react-router-dom"
import { t } from '../i18n/i18n'
import qrPoster from "../../assets/images/elements/qr_payment_poster.pdf"
import { useTheme } from "../../contexts/ThemeContext"
import { useAuth } from "../../contexts/AuthContext"

const ChurchLogo = () => (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M5 60 Q50 -10 95 60 L92 60 Q50 5 8 60 Z" fill="black"/>
        <rect x="46" y="32" width="8" height="34" fill="black"/>
        <rect x="36" y="40" width="28" height="6" fill="black"/>
        <path d="M50 64 L50 69 C40 69 22 66 12 73 L10 73 C10 65 24 53 45 61 Z" fill="black"/>
        <path d="M50 64 L50 69 C60 69 78 66 88 73 L90 73 C90 65 76 53 55 61 Z" fill="black"/>
        <path d="M50 71 L50 73 C40 73 20 71 10 75 L5 75 C12 80 25 80 50 80 Z" fill="black"/>
        <path d="M50 71 L50 73 C60 73 80 71 90 75 L95 75 C88 80 75 80 50 80 Z" fill="black"/>
    </svg>
)

export const Header = () => {
  const [isMenuActive, setIsMenuActive] = useState(false)
  const [donateOpen, setDonateOpen] = useState(false)
  const { isDark, toggleTheme } = useTheme()
  const { userProfile } = useAuth()

  const closeMenu = () => setIsMenuActive(false)

  return (
    <>
      {donateOpen && (
        <div className="donate-modal-overlay" onClick={() => setDonateOpen(false)}>
          <div className="donate-modal" onClick={e => e.stopPropagation()}>
            <button className="donate-modal-close" onClick={() => setDonateOpen(false)}>✕</button>
            <iframe src={qrPoster} title="QR Payment Poster" className="donate-modal-pdf"/>
            <a
              href="https://myiban.com.ua/l/9qcqqc"
              target="_blank"
              rel="noopener noreferrer"
              className="donate-modal-link"
            >
              https://myiban.com.ua/l/9qcqqc
            </a>
          </div>
        </div>
      )}

      <header className="header-nav">
        <div className="header-nav-inner">

          <Link to="/" className="logo-link" onClick={closeMenu} aria-label="На головну">
            <ChurchLogo />
          </Link>

          <span className="header-church-name">{t("headerChurchName")}</span>

          <nav className="header-main-nav" aria-label="Головна навігація">
            <ul className={`menu${isMenuActive ? ' active' : ''}`}>
              {nav.map((link) => (
                <li key={link.id}>
                  <Link to={link.url} onClick={!link.submenu ? closeMenu : undefined}>
                    {t(link.text)}
                    {link.submenu && (
                      <i className="ti ti-chevron-down chevron" aria-hidden="true"></i>
                    )}
                  </Link>
                  {link.submenu && (
                    <ul className="submenu">
                      {link.submenu.map((sub) => (
                        <li key={sub.id}>
                          <Link to={sub.url} onClick={closeMenu}>{t(sub.text)}</Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div className="header-actions">
            <button className="header-donate" onClick={() => setDonateOpen(true)}>
              <i className="ti ti-heart" aria-hidden="true"></i>
              <span className="donate-label">{t("headerDonate")}</span>
            </button>
            <button
              className="theme-toggle"
              onClick={toggleTheme}
              aria-label={isDark ? 'Денний режим' : 'Нічний режим'}
              title={isDark ? 'Денний режим' : 'Нічний режим'}
            >
              <i className={`ti ${isDark ? 'ti-sun' : 'ti-moon'}`} aria-hidden="true"></i>
            </button>
            {userProfile && (
              <Link to="/admin" className="header-admin-btn" title={userProfile.displayName || 'Адмін'}>
                🧑
              </Link>
            )}
            <Locale />
            <button
              className={`menu-toggle${isMenuActive ? ' active' : ''}`}
              onClick={() => setIsMenuActive(prev => !prev)}
              aria-label={isMenuActive ? 'Закрити меню' : 'Відкрити меню'}
              aria-expanded={isMenuActive}
            >
              <i className={`ti ${isMenuActive ? 'ti-x' : 'ti-menu-2'}`} aria-hidden="true"></i>
            </button>
          </div>

        </div>
      </header>
    </>
  )
}
